import { SCENE_INTERACTION } from "../../constants/scene";
import { TextureLoader } from 'three';
import { makeId } from "../MVC/dataHelpers";
import { getCookie, setCookie } from "../engine/helpers/cookie";
import AvatarGenerator from "./NameAvatarGenerator";
import { SOCKET_EVENTS } from "../../socket/Events";
import { isPageEmbedded } from "../engine/helpers/ui-logic";

class GuestWelcomeModal {
  constructor({ model }) {
    this.model = model;
    this.listOfAvatars = [];
    this.template = $(".guest-welcome-modal-holder");
    this.template.removeClass("is-active");
    this.title = this.template.find("#guest-welcome-title");
    this.header = this.template.find(".edit-profile-header");
    this.nameAvatarGenerator = new AvatarGenerator({ model });
    this.textureLoaderSilent = new TextureLoader();
    this.close();
    this.loadAvatars();

    this.model.socket.addEventListener(SOCKET_EVENTS.INIT_USERS, () => {
      if (this.model.config.isGuest) {
        let userName = getCookie('guestName');
        if (!userName) {
          userName = `Guest ${Math.round(Math.random() * 300)}`;
        }
        this.nameAvatarGenerator.input.val(userName);
        const userId = this.model.config.userId;
        this.nameAvatarGenerator.generate();
        let userAvatarUrl = this.nameAvatarGenerator.img.src;
        setCookie('guestAvatarUrl', userAvatarUrl, 30);
        setCookie('guestName', userName, 30);

        const data = {
          userId,
          userAvatarUrl,
          userName
        };
        this.model.config.userAvatarUrl = userAvatarUrl;
        this.model.dispatchEvent({ type: SCENE_INTERACTION.USER_AVATAR_CHANGED, data });
        this.model.userAvatarTexture = this.textureLoaderSilent.load(data.userAvatarUrl);
        this.model.saveProfile({ url: this.model.config.saveProfileUrl, data });
        this.close();
      } else {
        this.close();
      }
    })

    $('#signupLink').attr('href', `${window.location.origin}/user/register`).on('click', (e) => {
      if (window.openRegisterModal) {
        e.preventDefault();
        e.stopPropagation();
        window.openRegisterModal();
      }
    });
    $('#loginLink').attr('href', `${window.location.origin}/user/login`).on('click', (e) => {
      if (window.openLoginModal) {
        e.preventDefault();
        e.stopPropagation();
        window.openLoginModal();
      }
    });

    this.saveButton = $("#save-welcome-guest");
    this.saveButton.on("click", () => {
      // $("#save-profile").trigger("click");
      this.close();
    });

    $("#welcome-login-btn").on('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      window.location.assign(`${window.origin}/user/login`);
    });
    $("#welcome-enter-room").on('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      window.location.assign(`${window.origin}/user/register`);
    });
    $("#save-welcome-guest").on('click', async (e) => {
      e.preventDefault();
      e.stopPropagation();
      $('#create-guest-user input[name=userName]').val($("#guest-avatar-name").val())
      $("#save-profile").trigger("click");

      const userName = this.nameAvatarGenerator.input[0].value;
      const userId = this.model.config.userId;
      let userAvatarUrl = this.nameAvatarGenerator.img.src;
      this.model.config.userAvatarUrl = userAvatarUrl;

      let guestAvatarUrl = getCookie('guestAvatarUrl');
      let guestName = getCookie('guestName');
      if (userName != guestName) {
        setCookie('guestName', userName, 30);
      }
      if (userAvatarUrl != guestAvatarUrl) {
        setCookie('guestAvatarUrl', userAvatarUrl, 30);
      }
      console.log('getCookieL ', getCookie('guestName'), getCookie('guestAvatarUrl'));
      const data = {
        userId,
        userAvatarUrl,
        userName
      };
      this.model.dispatchEvent({ type: SCENE_INTERACTION.USER_AVATAR_CHANGED, data });
      this.model.userAvatarTexture = this.textureLoaderSilent.load(data.userAvatarUrl);
    });



  }
  open() {
    this.template.addClass("is-active");
    const title = this.title.html();
    this.title.html(`${title} ${this.model.sceneData.sceneName || this.model.sceneData.name}`);

  }
  close() {
    this.template.removeClass("is-active");
  }
  loadAvatars() {
    this.model.worldFetcher.getAvatars((avatars) => {
      this.listOfAvatars = avatars;
    })
  }
}

export { GuestWelcomeModal }
